// Types
import { Picture } from '../../picture/objects/picture';
import { ConnectedActivitiesState } from '../objects/connectedActivitiesState';
import { applyColumnResize } from '../../utils/list/utils/columnResize';
import { DEFAULT_CONNECTED_ACTIVITIES_COLUMNS } from '../utils/setConnectedActivitiesPreference';
// Action Types
import {
    ADD_INCLUDED_LOCALE,
    ADD_NOT_INCLUDED_LOCALE,
    ConnectedActivitiesActionTypes,
    DELETE_CUSTOM_PICTURE,
    DELETE_INCLUDED_LOCALE,
    DELETE_NOT_INCLUDED_LOCALE,
    MOVE_DOWN_COLUMN,
    MOVE_UP_COLUMN,
    RESET_ACTIVITY,
    RESET_FILTERS,
    SET_ACTIVITY,
    SET_COLUMNS,
    SET_SELECTED_ACTIVITIES,
    SET_EDIT_STEP,
    SET_EXPORT_TYPE,
    SET_LIMIT,
    SET_LIST,
    SET_ORDER_BY,
    SET_PAGE,
    SET_RUNNING,
    SET_SEARCH,
    TOGGLE_COLUMN,
    TOGGLE_EXPORT,
    TOGGLE_EXPORT_FULL,
    TOGGLE_FILTERS,
    TOGGLE_PICTURES_ACTIVATED,
    TOGGLE_PICTURES_ORDER,
    TOGGLE_REFRESH,
    UPDATE_ADDRESS,
    UPDATE_ADDRESS_SEARCH,
    UPDATE_AUDIO,
    UPDATE_CITY,
    UPDATE_CUT_LINE,
    UPDATE_DURATION_DAYS,
    UPDATE_DURATION_HOURS,
    UPDATE_DURATION_MINUTES,
    UPDATE_FILTER_CITY,
    UPDATE_FILTER_COUNTRY,
    UPDATE_FILTER_CREATED_DATE_GTE,
    UPDATE_FILTER_CREATED_DATE_LTE,
    UPDATE_FILTER_LAST_AUTHOR,
    UPDATE_FILTER_MODIFIED_DATE_GTE,
    UPDATE_FILTER_MODIFIED_DATE_LTE,
    UPDATE_FILTER_PERIOD,
    UPDATE_FILTER_PERIOD_TYPE,
    UPDATE_FILTER_PROVIDER,
    UPDATE_FILTER_PROVIDER_UPDATE,
    UPDATE_FILTER_STATUS,
    UPDATE_FOR_CHILDREN,
    UPDATE_FOR_DISABLED,
    UPDATE_GOOD_TO_KNOW,
    UPDATE_GOOGLE_ID,
    UPDATE_GUIDE,
    UPDATE_GUIDE_LANG,
    UPDATE_GUIDE_LANG_LOCALE,
    UPDATE_HOTEL_REQUIRED,
    UPDATE_INCLUDED_LOCALE,
    UPDATE_INCLUDED_LOCALE_TRANSLATE,
    UPDATE_LABEL_ECO,
    UPDATE_LATITUDE,
    UPDATE_LIST_ITEM_VISIBILITY,
    TOGGLE_LIST_ITEM_ACTIVATION,
    UPDATE_LONG_DESCRIPTION,
    UPDATE_LONGITUDE,
    UPDATE_NEED_PAX_WEIGHT,
    UPDATE_NOT_INCLUDED_LOCALE,
    UPDATE_NOT_INCLUDED_LOCALE_TRANSLATE,
    UPDATE_PICTURE_ORDER,
    UPDATE_PROVIDER_LIB,
    UPDATE_PROVIDER_REF,
    UPDATE_RATING,
    UPDATE_RECOMMENDED,
    UPDATE_SHORT_DESCRIPTION,
    UPDATE_SUPPLIER_NAME,
    UPDATE_TITLE,
    UPDATE_VOUCHER_MANUAL,
    UPDATE_VOUCHER_TEXT_LOCALE,
    UPDATE_ZIP_CODE,
    UPDATE_ZOOM,
    RESIZE_COLUMN
} from './actionTypes';
import { ADD_CUSTOM_PICTURES, PictureActionTypes } from '../../picture/redux/actionTypes';

const initialState: ConnectedActivitiesState = {
    activity: null,
    address: '',
    address_search: null,
    audio_guide: false,
    hotel_required: false,
    voucher_manual: false,
    label_eco: false,
    city: '',
    columns: DEFAULT_CONNECTED_ACTIVITIES_COLUMNS,
    count: 0,
    cover_picture: null,
    custom_pictures: [],
    custom_pictures_order: [],
    cut_line: false,
    description_lang: null,
    duration_days: 0,
    duration_hours: 0,
    duration_minutes: 60,
    edit_step: null,
    editor_pictures: null,
    email: '',
    export_full: false,
    export_list: false,
    export_type: 'CSV',
    filter_city: '',
    filter_country: '',
    filter_created_date_gte: null,
    filter_created_date_lte: null,
    filter_last_author: '',
    filter_modified_date_gte: null,
    filter_modified_date_lte: null,
    filter_open: false,
    filter_period: 'CREATION',
    filter_period_type: 0,
    filter_provider: [],
    filter_provider_update: 'ALL',
    filter_status: 'ALL',
    for_children: false,
    for_disabled: false,
    good_to_know: {},
    google_id: '',
    google_id_error: '',
    guide: false,
    guide_lang: '',
    guide_lang_locales: {},
    included: [],
    included_locales: {},
    latitude: '',
    latitude_error: '',
    limit: 50,
    list: null,
    long_description: {},
    longitude: '',
    longitude_error: '',
    max_pax: 0,
    need_pax_weight: false,
    not_included: [],
    not_included_locales: {},
    order: 'asc',
    order_by: 'title',
    original_product: null,
    page: 0,
    phone_number: '',
    pictures: [],
    pictures_order: false,
    product_number_model: false,
    provider_lib: '',
    provider_pictures: [],
    provider_ref: '',
    rating: 5,
    recommended: false,
    refresh: false,
    running: false,
    search: '',
    short_description: {},
    supplier_address: '',
    supplier_city_name: '',
    supplier_name: '',
    supplier_phone: '',
    supplier_zip_code: '',
    title: {},
    visibility: 'PUBLIC',
    voucher_text: '',
    voucher_text_locales: {},
    website: '',
    zip_code: '',
    zoom_level: 4,
    selected_activities: []
};

export default (state: ConnectedActivitiesState = initialState, action: ConnectedActivitiesActionTypes | PictureActionTypes): ConnectedActivitiesState => {
    switch (action.type) {
        case ADD_CUSTOM_PICTURES: {
            return { ...state, custom_pictures: [...state.custom_pictures, ...action.payload] };
        }
        case ADD_INCLUDED_LOCALE: {
            const included_locales = { ...state.included_locales };
            if (!included_locales[action.payload]) {
                included_locales[action.payload] = [];
            }
            const included = [...included_locales[action.payload]];
            included.push('');
            included_locales[action.payload] = included;
            return { ...state, included_locales: included_locales };
        }
        case ADD_NOT_INCLUDED_LOCALE: {
            const not_included_locales = { ...state.not_included_locales };
            if (!not_included_locales[action.payload]) {
                not_included_locales[action.payload] = [];
            }
            const not_included = [...not_included_locales[action.payload]];
            not_included.push('');
            not_included_locales[action.payload] = not_included;
            return { ...state, not_included_locales: not_included_locales };
        }
        case DELETE_CUSTOM_PICTURE: {
            const custom_pictures = [...state.custom_pictures];
            custom_pictures.splice(action.payload, 1);
            return { ...state, custom_pictures: custom_pictures };
        }
        case DELETE_INCLUDED_LOCALE: {
            const { id, index } = action.payload;
            const included_locales = { ...state.included_locales };
            const included = [...included_locales[id]];
            included.splice(index, 1);
            included_locales[id] = included;
            return { ...state, included_locales: included_locales };
        }
        case DELETE_NOT_INCLUDED_LOCALE: {
            const { id, index } = action.payload;
            const not_included_locales = { ...state.not_included_locales };
            const not_included = [...not_included_locales[id]];
            not_included.splice(index, 1);
            not_included_locales[id] = not_included;
            return { ...state, not_included_locales: not_included_locales };
        }
        case MOVE_DOWN_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = { ...columns[action.payload + 1] };
            columns[action.payload + 1] = columns[action.payload];
            columns[action.payload + 1].last_updated = true;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case MOVE_UP_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = { ...columns[action.payload - 1] };
            columns[action.payload - 1] = columns[action.payload];
            columns[action.payload - 1].last_updated = true;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case RESET_ACTIVITY: {
            return {
                ...state,
                activity: null,
                address: '',
                address_search: null,
                audio_guide: false,
                hotel_required: false,
                voucher_manual: false,
                label_eco: false,
                city: '',
                cover_picture: null,
                custom_pictures: [],
                custom_pictures_order: [],
                cut_line: false,
                description_lang: null,
                duration_days: 0,
                duration_hours: 0,
                duration_minutes: 60,
                edit_step: null,
                editor_pictures: null,
                email: '',
                for_children: false,
                for_disabled: false,
                good_to_know: {},
                google_id: '',
                google_id_error: '',
                guide: false,
                guide_lang: '',
                guide_lang_locales: {},
                included: [],
                included_locales: {},
                latitude: '',
                latitude_error: '',
                long_description: {},
                longitude: '',
                longitude_error: '',
                max_pax: 0,
                need_pax_weight: false,
                not_included: [],
                not_included_locales: {},
                original_product: null,
                phone_number: '',
                pictures: [],
                pictures_order: false,
                product_number_model: false,
                provider_lib: '',
                provider_pictures: [],
                provider_ref: '',
                rating: 5,
                recommended: false,
                short_description: {},
                supplier_address: '',
                supplier_city_name: '',
                supplier_name: '',
                supplier_phone: '',
                supplier_zip_code: '',
                title: {},
                visibility: 'PUBLIC',
                voucher_text: '',
                voucher_text_locales: {},
                website: '',
                zip_code: '',
                zoom_level: 4
            };
        }
        case RESET_FILTERS: {
            return {
                ...state,
                filter_city: '',
                filter_country: '',
                filter_created_date_gte: null,
                filter_created_date_lte: null,
                filter_last_author: '',
                filter_modified_date_gte: null,
                filter_modified_date_lte: null,
                filter_period: 'CREATION',
                filter_period_type: 0,
                filter_provider: [],
                filter_provider_update: 'ALL',
                filter_status: 'ALL'
            };
        }
        case SET_ACTIVITY: {
            const activity = action.payload;
            const good_to_know:{} & {[index: string]: any} = {};
            const guide_lang_locales: {} & {[index: string]: any} = {};
            const included_locales: {} & {[index: string]: any} = {};
            const long_description: {} & {[index: string]: any} = {};
            const not_included_locales: {} & {[index: string]: any} = {};
            const short_description: {} & {[index: string]: any} = {};
            const voucher_text_locales: {} & {[index: string]: any} = {};
            const title: {} & {[index: string]: any} = {};
            let has_french = false;
            action.payload.localization.map(locale => {
                if (locale.locale === 1) {
                    has_french = true;
                }
                good_to_know[locale.locale] = locale.good_to_know;
                guide_lang_locales[locale.locale] = locale.guide_lang;
                included_locales[locale.locale] = locale.included;
                long_description[locale.locale] = locale.long_description;
                not_included_locales[locale.locale] = locale.not_included;
                short_description[locale.locale] = locale.short_description;
                voucher_text_locales[locale.locale] = locale.voucher_text;
                title[locale.locale] = locale.title;
            });
            if (!has_french) {
                good_to_know['1'] = action.payload.good_to_know !== null ? action.payload.good_to_know : '';
                guide_lang_locales['1'] = action.payload.guide_lang;
                included_locales['1'] = action.payload.included;
                long_description['1'] = action.payload.long_description !== null ? action.payload.long_description : '';
                not_included_locales['1'] = action.payload.not_included;
                short_description['1'] = action.payload.short_description !== null ? action.payload.short_description : '';
                title['1'] = action.payload.title !== null ? action.payload.title : '';
                voucher_text_locales['1'] = action.payload.voucher_text !== null ? action.payload.voucher_text : '';
            }
            const custom_pictures: Picture[] = [];
            const provider_pictures: (Picture & {activated: boolean})[] = [];
            if (activity.pictures !== null) {
                activity.pictures.map(custom_picture => {
                    let activated = false;
                    if (activity.original_product !== null && activity.original_product.pictures !== null) {
                        activity.original_product.pictures.map(picture => {
                            if (custom_picture.id === picture.id) {
                                activated = true;
                            }
                        });
                    } else if (activity.original_product === null) {
                        provider_pictures.push({ ...custom_picture, activated: true });
                    }
                    if (activity?.original_product !== null && !activated) {
                        custom_pictures.push({ ...custom_picture });
                    }
                });
            }
            if (activity.original_product !== null && activity.original_product.pictures !== null) {
                activity.original_product.pictures.map(picture => {
                    let activated = false;
                    if (activity.pictures !== null) {
                        activity.pictures.map(custom_picture => {
                            if (custom_picture.id === picture.id) {
                                activated = true;
                            }
                        });
                    }
                    provider_pictures.push({ ...picture, activated: activated });
                });
            }
            return { ...state,
                activity: action.payload,
                address: activity.place !== null && activity.place.address !== null ? activity.place.address : '',
                address_search: null,
                audio_guide: activity.audio_guide,
                voucher_manual: activity.voucher_manual,
                label_eco: activity.label_eco,
                hotel_required: activity.hotel_required,
                city: activity.place !== null && activity.place.city_name !== null ? activity.place.city_name : '',
                cover_picture: activity.cover_picture,
                custom_pictures: custom_pictures,
                custom_pictures_order: activity.pictures,
                cut_line: activity.cut_line !== null ? activity.cut_line : false,
                description_lang: activity.description_lang,
                duration_days: ((activity.duration - (activity.duration % 60)) - ((activity.duration - (activity.duration % 60)) % 1440)) / 1440,
                duration_hours: ((activity.duration - (activity.duration % 60)) / 60) % 24,
                duration_minutes: activity.duration % 60,
                email: activity.email !== null ? activity.email : '',
                for_children: activity.for_children,
                for_disabled: activity.for_disabled,
                good_to_know: good_to_know,
                google_id: activity.place !== null && activity.place.google_id !== null ? activity.place.google_id : '',
                guide: activity.guide,
                guide_lang: activity.guide_lang !== null ? activity.guide_lang : '',
                guide_lang_locales: guide_lang_locales,
                included: activity.included !== null ? activity.included : [],
                included_locales: included_locales,
                latitude: activity.place !== null && activity.place.latitude !== null ? activity.place.latitude : '',
                long_description: long_description,
                longitude: activity.place !== null && activity.place.longitude !== null ? activity.place.longitude : '',
                max_pax: activity.max_pax !== null ? activity.max_pax : 0,
                need_pax_weight: activity.need_pax_weight,
                not_included: activity.not_included !== null ? activity.not_included : [],
                not_included_locales: not_included_locales,
                original_product: activity.original_product,
                phone_number: activity.phone_number,
                pictures: activity.pictures,
                product_number_model: activity.product_number_model,
                provider_lib: activity.provider_lib !== null ? activity.provider_lib : '',
                provider_pictures: provider_pictures,
                provider_ref: activity.provider_ref !== null ? activity.provider_ref : activity.product_code,
                rating: activity.rating !== null ? activity.rating : 0,
                recommended: activity.recommended,
                short_description: short_description,
                supplier_address: activity.supplier_address !== null ? activity.supplier_address : '',
                supplier_city_name: activity.supplier_city_name !== null ? activity.supplier_city_name : '',
                supplier_name: activity.supplier_name !== null ? activity.supplier_name : '',
                supplier_phone: activity.supplier_phone !== null ? activity.supplier_phone : '',
                supplier_zip_code: activity.supplier_zip_code !== null ? activity.supplier_zip_code : '',
                title: title,
                visibility: activity.visibility,
                voucher_text: activity.voucher_text !== null ? activity.voucher_text : '',
                voucher_text_locales: voucher_text_locales,
                website: activity.website,
                zip_code: activity.place !== null && activity.place.zip_code !== null ? activity.place.zip_code : '',
                zoom_level: activity.place !== null && activity.place.zoom !== null ? activity.place.zoom : 4,
            };
        }
        case SET_EDIT_STEP: {
            return { ...state, edit_step: action.payload };
        }
        case SET_EXPORT_TYPE: {
            return { ...state, export_type: action.payload };
        }
        case SET_LIMIT: {
            return { ...state, limit: action.payload };
        }
        case SET_LIST: {
            const { count, results } = action.payload;
            return { ...state, count: count, list: results, running: false };
        }
        case SET_ORDER_BY: {
            return { ...state, list: null, order_by: action.payload, order: state.order_by === action.payload && state.order === 'asc' ? 'desc': 'asc' };
        }
        case SET_PAGE: {
            return { ...state, list: null, page: action.payload };
        }
        case SET_RUNNING: {
            return { ...state, running: action.payload };
        }
        case SET_SEARCH: {
            return { ...state, list: null, page: 0, search: action.payload };
        }
        case TOGGLE_COLUMN: {
            const columns = [...state.columns];
            const column = { ...columns[action.payload] };
            column.checked = !column.checked;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case TOGGLE_EXPORT: {
            return { ...state, export_list: action.payload };
        }
        case TOGGLE_EXPORT_FULL: {
            return { ...state, export_full: !state.export_full };
        }
        case TOGGLE_FILTERS: {
            return { ...state, filter_open: !state.filter_open };
        }
        case TOGGLE_PICTURES_ACTIVATED: {
            const provider_pictures = [...state.provider_pictures];
            const picture = { ...provider_pictures[action.payload] };
            picture.activated = !picture.activated;
            provider_pictures[action.payload] = picture;
            return { ...state, provider_pictures: provider_pictures };
        }
        case TOGGLE_PICTURES_ORDER: {
            return { ...state, pictures_order: !state.pictures_order };
        }
        case TOGGLE_REFRESH: {
            return { ...state, refresh: !state.refresh };
        }
        case UPDATE_ADDRESS: {
            return { ...state, address: action.payload };
        }
        case UPDATE_ADDRESS_SEARCH: {
            return { ...state, address_search: action.payload };
        }
        case UPDATE_AUDIO: {
            return { ...state, audio_guide: action.payload };
        }
        case UPDATE_HOTEL_REQUIRED: {
            return { ...state, hotel_required: action.payload };
        }
        case UPDATE_VOUCHER_MANUAL: {
            return { ...state, voucher_manual: action.payload };
        }
        case UPDATE_LABEL_ECO: {
            return { ...state, label_eco: action.payload };
        }
        case UPDATE_CITY: {
            return { ...state, city: action.payload };
        }
        case UPDATE_CUT_LINE: {
            return { ...state, cut_line: action.payload };
        }
        case UPDATE_DURATION_DAYS: {
            return { ...state, duration_days: action.payload };
        }
        case UPDATE_DURATION_HOURS: {
            return { ...state, duration_hours: action.payload };
        }
        case UPDATE_DURATION_MINUTES: {
            return { ...state, duration_minutes: action.payload };
        }
        case UPDATE_FILTER_CITY: {
            return { ...state, filter_city: action.payload };
        }
        case UPDATE_FILTER_COUNTRY: {
            return { ...state, filter_country: action.payload };
        }
        case UPDATE_FILTER_CREATED_DATE_GTE: {
            return { ...state, filter_created_date_gte: action.payload };
        }
        case UPDATE_FILTER_CREATED_DATE_LTE: {
            return { ...state, filter_created_date_lte: action.payload };
        }
        case UPDATE_FILTER_LAST_AUTHOR: {
            return { ...state, filter_last_author: action.payload };
        }
        case UPDATE_FILTER_MODIFIED_DATE_GTE: {
            return { ...state, filter_modified_date_gte: action.payload };
        }
        case UPDATE_FILTER_MODIFIED_DATE_LTE: {
            return { ...state, filter_modified_date_lte: action.payload };
        }
        case UPDATE_FILTER_PERIOD: {
            const period = action.payload;
            return {
                ...state,
                filter_period: period,
                filter_period_type: 0,
                filter_created_date_gte: period === 'MODIFICATION' ? null : state.filter_created_date_gte,
                filter_created_date_lte: period === 'MODIFICATION' ? null : state.filter_created_date_lte,
                filter_modified_date_gte: period === 'CREATION' ? null : state.filter_modified_date_gte,
                filter_modified_date_lte: period === 'CREATION' ? null : state.filter_modified_date_lte,
            };
        }
        case UPDATE_FILTER_PERIOD_TYPE: {
            return { ...state, filter_period_type: action.payload };
        }
        case UPDATE_FILTER_PROVIDER: {
            return { ...state, filter_provider: action.payload };
        }
        case UPDATE_FILTER_PROVIDER_UPDATE: {
            return { ...state, filter_provider_update: action.payload };
        }
        case UPDATE_FILTER_STATUS: {
            return { ...state, filter_status: action.payload };
        }
        case UPDATE_FOR_CHILDREN: {
            return { ...state, for_children: action.payload };
        }
        case UPDATE_FOR_DISABLED: {
            return { ...state, for_disabled: action.payload };
        }
        case UPDATE_GOOD_TO_KNOW: {
            const { id, value } = action.payload;
            const good_to_know = { ...state.good_to_know };
            good_to_know[id] = value;
            return { ...state, good_to_know: good_to_know };
        }
        case UPDATE_GOOGLE_ID: {
            return { ...state, google_id: action.payload };
        }
        case UPDATE_GUIDE: {
            return { ...state, guide: action.payload };
        }
        case UPDATE_GUIDE_LANG: {
            return { ...state, guide_lang: action.payload };
        }
        case UPDATE_GUIDE_LANG_LOCALE: {
            const { id, value } = action.payload;
            const guide_lang_locales = { ...state.guide_lang_locales };
            guide_lang_locales[id] = value;
            return { ...state, guide_lang_locales: guide_lang_locales };
        }
        case UPDATE_INCLUDED_LOCALE: {
            const { id, index, value } = action.payload;
            const included_locales = { ...state.included_locales };
            const included = [...included_locales[id]];
            included[index] = value;
            included_locales[id] = included;
            return { ...state, included_locales: included_locales };
        }
        case UPDATE_INCLUDED_LOCALE_TRANSLATE: {
            const { id, translations } = action.payload;
            const included_locales = { ...state.included_locales };
            included_locales[id] = translations;
            return { ...state, included_locales: included_locales };
        }
        case UPDATE_LATITUDE: {
            return { ...state, latitude: action.payload };
        }
        case UPDATE_LIST_ITEM_VISIBILITY: {
            if (state.list !== null) {
                const list = [...state.list];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].owner === null) {
                        if (action.payload.original_product !== null && list[i].id === action.payload.original_product.id) {
                            list[i] = action.payload;
                            break;
                        }
                    } else {
                        if (list[i].id === action.payload.id) {
                            list[i].visibility = action.payload.visibility;
                            break;
                        }
                    }
                }
                return { ...state, list: list };
            }
            return state;
        }
        case TOGGLE_LIST_ITEM_ACTIVATION: {
            return { ...state, list: state.list?.map(item => action.payload.id.includes(item.id) ? { ...item, deactivated: action.payload.deactivated } : item) || [] };
        }
        case UPDATE_LONGITUDE: {
            return { ...state, longitude: action.payload };
        }
        case UPDATE_LONG_DESCRIPTION: {
            const { id, value } = action.payload;
            const long_description = { ...state.long_description };
            long_description[id] = value;
            return { ...state, long_description: long_description };
        }
        case UPDATE_NEED_PAX_WEIGHT: {
            return { ...state, need_pax_weight: action.payload };
        }
        case UPDATE_NOT_INCLUDED_LOCALE: {
            const { id, index, value } = action.payload;
            const not_included_locales = { ...state.not_included_locales };
            const not_included = [...not_included_locales[id]];
            not_included[index] = value;
            not_included_locales[id] = not_included;
            return { ...state, not_included_locales: not_included_locales };
        }
        case UPDATE_NOT_INCLUDED_LOCALE_TRANSLATE: {
            const { id, translations } = action.payload;
            const not_included_locales = { ...state.not_included_locales };
            not_included_locales[id] = translations;
            return { ...state, not_included_locales: not_included_locales };
        }
        case UPDATE_PICTURE_ORDER: {
            const { drag_index, hover_index } = action.payload;
            const custom_pictures_order = [...state.custom_pictures_order];
            custom_pictures_order.splice(drag_index, 1);
            custom_pictures_order.splice(hover_index, 0, state.custom_pictures_order[drag_index]);
            return { ...state, custom_pictures_order: custom_pictures_order };
        }
        case UPDATE_PROVIDER_LIB: {
            return { ...state, provider_lib: action.payload };
        }
        case UPDATE_PROVIDER_REF: {
            return { ...state, provider_ref: action.payload };
        }
        case UPDATE_RATING: {
            return { ...state, rating: action.payload };
        }
        case UPDATE_RECOMMENDED: {
            return { ...state, recommended: action.payload };
        }
        case UPDATE_SHORT_DESCRIPTION: {
            const { id, value } = action.payload;
            const short_description = { ...state.short_description };
            short_description[id] = value;
            return { ...state, short_description: short_description };
        }
        case UPDATE_SUPPLIER_NAME: {
            return { ...state, supplier_name: action.payload };
        }
        case UPDATE_TITLE: {
            const { id, value } = action.payload;
            const title = { ...state.title };
            title[id] = value;
            return { ...state, title: title };
        }
        case UPDATE_VOUCHER_TEXT_LOCALE: {
            const { id, value } = action.payload;
            const voucher_text_locales = { ...state.voucher_text_locales };
            voucher_text_locales[id] = value;
            return { ...state, voucher_text_locales: voucher_text_locales };
        }
        case UPDATE_ZIP_CODE: {
            return { ...state, zip_code: action.payload };
        }
        case UPDATE_ZOOM: {
            return { ...state, zoom_level: action.payload };
        }
        case SET_COLUMNS: {
            return { ...state, columns: action.payload };
        }
        case SET_SELECTED_ACTIVITIES: {
            return { ...state, selected_activities: action.payload };
        }
        case RESIZE_COLUMN: {
            return { ...state, columns: applyColumnResize(state.columns, action.payload) };
        }
        default:
            return state;
    }
};